/**
 * ================================================================================================
 *  A COLLAPSIBLE GROUP OF FIELDS. **2026-10-25.**
 * ================================================================================================
 *
 * Owner: *"קבוצות שדות מתקפלות"*, from the reference card we were shown, where פרטים בסיסיים · פרטי מס · כתובת ·
 * פרטי יצירת קשר each open on their own.
 *
 * A tab holds one SUBJECT; a group holds one PART of that subject. The difference matters for
 * *"save and come back later"*: tabs are where a person resumes, groups are what stops the tab they
 * resumed into being a wall of twelve fields.
 *
 * ── `defaultOpen` IS A JUDGEMENT AND IT IS THE CALLER'S ─────────────────────────────────────────
 *
 * The group holding the fields somebody came to fill in opens; the ones holding what is already
 * settled do not. A card where everything is collapsed is a card where nothing is visible, which is
 * worse than the stack it replaced.
 *
 * ── IT IS A `<details>`, FOR THE REASONS IN `InfoNote` ──────────────────────────────────────────
 *
 * Native disclosure: keyboard-operable, announced as one, no state to own, and — the part that
 * matters on a form — **the content of a closed `<details>` is still in the DOM**, so a field
 * inside a collapsed group is still submitted with the form and still found by the browser's own
 * find-in-page. A conditional render would silently drop it.
 */

import type { ReactNode } from 'react';

export interface FieldGroupProps {
  readonly titleHe: string;
  /** One line under the title, visible whether the group is open or shut. */
  readonly leadHe?: string;
  readonly defaultOpen?: boolean;
  readonly children: ReactNode;
}

export function FieldGroup({
  titleHe,
  leadHe,
  defaultOpen = false,
  children,
}: FieldGroupProps): JSX.Element {
  return (
    <details className="field-group" open={defaultOpen}>
      <summary className="field-group__summary">
        <span className="field-group__title">{titleHe}</span>
        {leadHe === undefined ? null : <span className="field-group__lead">{leadHe}</span>}
      </summary>
      <div className="field-group__body">{children}</div>
    </details>
  );
}
